import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Button } from "../components/ui/button"
import { Phone, Calendar } from "lucide-react"
import { HeaderNav } from "./header-nav"

export function Header() {
  const [scrolled, setScrolled] = useState(false)

  // Add scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <header className="sticky top-0 z-50 w-full bg-white border-b shadow-sm">
      <div className="container flex items-center justify-between h-16 px-4 mx-auto">
        <div className="flex items-center gap-2">
          <Link to="/">
            <img
              src="/images/pranaam-logo.png"
              alt="Pranaam Hospitals Logo"
              width={120}
              height={60}
              className="h-12 w-auto"
            />
          </Link>
        </div>

        <HeaderNav />

        <div className="hidden md:flex items-center gap-4">
          <div className="flex items-center gap-2">
            <Phone className="w-4 h-4 text-primary animate-pulse" />
            <span className="text-sm font-medium">Emergency: +91 99660 60000</span>
          </div>
          <Button size="sm" className="gap-2 font-heading" asChild>
            <Link to="/book-appointment">
              <Calendar className="w-4 h-4" />
              <span>Book Now</span>
            </Link>
          </Button>
        </div>
      </div>
    </header>
  )
}
